import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve a stored media reference to a loadable URL.
// Uploaded images are stored as relative "/api/files/..." (portable across domains);
// external images keep their absolute http(s) URL.
export const mediaUrl = (v) => (!v ? v : v.startsWith("http") ? v : `${BACKEND_URL}${v}`);

export const api = axios.create({ baseURL: API, withCredentials: true });

export const endpoints = {
  home: () => Promise.all([
    api.get("/settings"), api.get("/statistics"), api.get("/sectors"),
    api.get("/portfolio"), api.get("/insights", { params: { limit: 3 } }),
  ]),
  sectors: () => api.get("/sectors").then(r => r.data),
  statistics: () => api.get("/statistics").then(r => r.data),
  portfolio: (rel) => api.get("/portfolio", { params: rel ? { relationship_type: rel } : {} }).then(r => r.data),
  insights: (category) => api.get("/insights", { params: category ? { category } : {} }).then(r => r.data),
  insight: (slug) => api.get(`/insights/${slug}`).then(r => r.data),
  contact: (data) => api.post("/contact", data).then(r => r.data),
  newsletter: (email) => api.post("/newsletter", { email }).then(r => r.data),
  opportunity: (formData) => api.post("/opportunity", formData, { headers: { "Content-Type": "multipart/form-data" } }).then(r => r.data),
};
